import { AppThunk } from '../store';
import { logout as logoutAction } from '../stores/authStore';
import { baseAxiosClient } from '../../clients/axios-client';
import Config from '../../config';

export const logoutUser = (): AppThunk => async (dispatch, getState) => {
	const token = getState().authState.astroToken;
	try {
		await baseAxiosClient({
			url: `${Config.apiBaseUrl}/auth/logout`,
			method: 'POST',
			withCredentials: true,
			headers: {
				'X-Client-Type': 'web',
				...(token ? { authorization: `Bearer ${token}` } : {}),
			},
		});
	} catch (e) {
		// Even if the network call fails, clear local auth state.
	} finally {
		dispatch(logoutAction());
	}
};
